module.exports = __webpack_public_path__ + "img/19.1b96bfc1.svg";